import { render, staticRenderFns } from "./DejavooCardForm.vue?vue&type=template&id=88e8498a"
import script from "./DejavooCardForm.vue?vue&type=script&lang=js"
export * from "./DejavooCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports